import { useState, useEffect, useCallback } from 'react'
import { PAYMENT_RETRY_TIMEOUT_SECONDS } from '../constants/payment'

const useRetryPayment = (createdAt) => {
  const [seconds, setSeconds] = useState(0)
  const [isActive, setIsActive] = useState(false)

  const calculateRemainingTime = useCallback(() => {
    if (!createdAt) return 0

    const createdTime = new Date(createdAt).getTime()
    const elapsed = Math.floor((Date.now() - createdTime) / 1000)
    return Math.max(0, PAYMENT_RETRY_TIMEOUT_SECONDS - elapsed)
  }, [createdAt])

  const startCountdown = useCallback(() => {
    const remaining = calculateRemainingTime()

    if (remaining > 0) {
      setSeconds(remaining)
      setIsActive(true)
    } else {
      setSeconds(0)
      setIsActive(false)
    }
  }, [calculateRemainingTime])

  const formatTime = useCallback(() => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }, [seconds])

  useEffect(() => {
    startCountdown()
  }, [startCountdown])

  useEffect(() => {
    if (!isActive || seconds <= 0) return

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          setIsActive(false)
          return 0
        }
        return prevSeconds - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isActive, seconds])

  const canRetry = seconds === 0 && createdAt
  const isCountingDown = isActive && seconds > 0

  return {
    seconds,
    canRetry,
    isCountingDown,
    formatTime,
  }
}

export default useRetryPayment
